// Get this on https://www.syncfusion.com/account/claim-license-key
export const SyncFusionLicense =
	'Ngo9BigBOggjHTQxAR8/V1JFaF5cXGRCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdmWH5fd3VURmNYUU10XEJWYEg=';

// Get this on https://devs.stimulsoft.com/#/howtoactivate/Js
export const StimulsoftReportJSLicense =
	'6vJhGtLLLz2GNviWmUTrhSqnOItdDwjBylQzQcAOiHlsl/+HV0nLCv5O4pNVma32bAOodVJQz3lcenQb1Hl1ShjZer' +
	'WwBirZPupY4lPmke38iZ2uDJoD1x3R58QG2pJ18OmUg8K8DtB2iSeUIS8ThzCzsPs1txwtJ926sVRUTdUl/i9MGE8N' +
	'buXsprZjKgBLHBwqt8wjNBtyjMU2L7SV6MG1GdaEt/5bSUWW36Dup+YjP/tm5SaFd/e4nJu8yUIaA1ICXdwUTKb9Um' +
	'fYp8hXSJfrFZzmd8HRwzDpcDQ9OtWUIfRCjR+mmGo2lDJmrL1+8qiTM29dX7PmZsqClmhv30bewNHXTUYOSXu/XXaB' +
	'Pnw6b4G7qygP9Q4/fREhy366zmrvDf9PfV2rqNOUB+Guo5Pk/9WZzYpOICo3Lvk65EPbnbhXsR4CLbLhwBpTQuF2zi' +
	'RYEAUSFHJicT9URzSCgOa92u3u2NMEk+DJN/cOoFV0+u0XdR1ZfkvmmYalwHh70zNeyitWaX34dN0hTqMNIC+k9v81' +
	'6eI10ph0BTYhtdCz4QLLFp1NcqD8W51o6KWKOndKgZPQ8EplH58SVvZQyQ==';
